module.exports = __webpack_public_path__ + "static/img/Gacha09.c7c7181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha09.png
// module id = KOMb
// module chunks = 1